import { IEntity } from "@/entity/shared/EntityStoreTypes";
import ApiBase from "./api-base";

class EntityApi extends ApiBase<IEntity> {
    constructor(urlBase: string = 'api/entity') {
        super(urlBase);
    }
}
export const entityApi: EntityApi = new EntityApi();
